import { render, staticRenderFns } from "./CoFooterPublic.vue?vue&type=template&id=3cb730fe&"
import script from "./CoFooterPublic.vue?vue&type=script&lang=ts&"
export * from "./CoFooterPublic.vue?vue&type=script&lang=ts&"
import style0 from "./CoFooterPublic.vue?vue&type=style&index=0&id=3cb730fe&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports